<a *ngIf="title" class="card-link" (click)="select()" [title]="''">
  <div class="card" [ngClass]="{'linkNewProject': id === 'linkNewProject', 'linkExistingProject' : id === 'linkExistingProject',
     'unlinkProject' : id === 'unlinkProject', 'migrateProject' : id === 'migrateProject' }">
    <div class="card-body">
      <div class="card-title" isEllipsisActive>{{title | translate}}</div>
      <div class="card-img" [inlineSVG]="image"></div>
    </div>
  </div>
</a>